import {safeSessionStorage} from '../../util/localStorage';

export const setRunDetailsSourcePath = () => {
  // Store the current path in sessionStorage before navigating
  safeSessionStorage.setItem(
    'runDetailsSourcePath',
    window.location.pathname + window.location.search
  );
};
